import { createSelector } from 'reselect';
import { RootState } from '../../../types';
import { EntityTypes } from '../../../constants/entities';
import { IEntityReducer } from '../../reducers/entities';
import { IVerificationRequest, IVerificationRequestDAO } from 'types/domain/verification';
import { parseCertificateDAO } from '../admin/certificate';
import { getEntities } from '../utils/getEntities';
import { IOrgUserCertificate, IOrgUserCertificateDAO } from 'types/domain/user';
import { ISessionReducer, Mode } from 'core/slices/session';
import { selectSession } from './session';
import { IPreviewState } from 'core/slices/preview';

const entity = (state: RootState) => state.entity.present;
const id = (state: RootState, id?: number) => id || state.state[EntityTypes.VERIFICATION_REQUEST];
const session = selectSession;
const preview = (state: RootState) => state.preview;

export const selectVerificationRequest = createSelector([entity, id, session, preview], parseVerificationRequestDAO);

function parseOrganisationUserCertificateDAO(entity: IEntityReducer, id, session) {
  const organisationUserCertificate: IOrgUserCertificate = entity[EntityTypes.ORG_USER_CERTIFICATE][id];

  return {
    ...organisationUserCertificate,
    name: session.name,
    certificate: parseCertificateDAO(entity, organisationUserCertificate.certificateId),
  } as IOrgUserCertificateDAO;
}

export function parseVerificationRequestDAO(
  entity,
  id,
  session: ISessionReducer = null,
  preview: IPreviewState = null,
) {
  if (!id) return null;

  const request: IVerificationRequest = entity[EntityTypes.VERIFICATION_REQUEST][id];

  return request
    ? ({
        ...request,
        verification: request.verificationId ? entity[EntityTypes.VERIFICATION][request.verificationId] : null,
        //certificate: request.certificateId ? parseCertificateDAO(entity, request.certificateId) : null,
        text: request.textId ? entity[EntityTypes.TEXT][request.textId] : null,
        image: request.imageId ? entity[EntityTypes.IMAGE][request.imageId] : null,
        entities: getEntities(entity, EntityTypes.VERIFICATION_REQUEST_ENTITY, 'verificationRequestId', request.id),
        certificate: request.certificateId ? parseCertificateDAO(entity, request.certificateId) : null,
        organisationUserCertificate:
          session && session.mode === Mode.LEARNING
            ? request.organisationUserCertificateId
              ? parseOrganisationUserCertificateDAO(entity, request.organisationUserCertificateId, session)
              : null
            : request.certificateId && session && preview
            ? {
                certificate: parseCertificateDAO(entity, request.certificateId),
                name: session.name,
                status: preview.certificates[request.certificateId]?.status,
              }
            : null,
      } as IVerificationRequestDAO)
    : null;
}
